import { render, staticRenderFns } from "./CartEmpty.vue?vue&type=template&id=574ebe9a&"
import script from "./CartEmpty.vue?vue&type=script&lang=js&"
export * from "./CartEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports